import React, { useEffect, useState } from 'react';
import {
  OPEN_STORAGE_SETTINGS_EVENT,
  subscribeStorageConsent,
  saveStorageConsent,
  StorageConsentRecord,
} from '../privacy/storageConsent';
import './CookieBanner.css';

const CookieBanner: React.FC = () => {
  const [consent, setConsent] = useState<StorageConsentRecord | null>(null);
  const [loaded, setLoaded] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    return subscribeStorageConsent((savedConsent) => {
      setConsent(savedConsent);
      setIsOpen(savedConsent === null);
      setLoaded(true);
    });
  }, []);

  useEffect(() => {
    const openSettings = () => setIsOpen(true);
    window.addEventListener(OPEN_STORAGE_SETTINGS_EVENT, openSettings);
    return () => window.removeEventListener(OPEN_STORAGE_SETTINGS_EVENT, openSettings);
  }, []);

  const saveChoice = (allowOptionalStorage: boolean) => {
    const nextConsent = saveStorageConsent({
      analytics: allowOptionalStorage,
      marketing: allowOptionalStorage,
    });
    setConsent(nextConsent);
    setIsOpen(false);
  };

  if (!loaded || !isOpen) {
    return null;
  }

  return (
    <section
      className="cookie-banner"
      aria-label="Cookie and storage notice"
      data-consent-configured={consent ? 'true' : 'false'}
    >
      <div className="cookie-banner-text">
        <strong>Cookies and storage</strong>
        <span>
          We use necessary storage for sign-in, security, and preferences. Optional analytics and
          affiliate referral measurement run only when you accept them.
        </span>
      </div>
      <div className="cookie-banner-actions">
        <a href="/cookies">Details</a>
        <button type="button" onClick={() => saveChoice(false)}>
          Necessary only
        </button>
        <button type="button" className="primary" onClick={() => saveChoice(true)}>
          Accept all
        </button>
      </div>
    </section>
  );
};

export default CookieBanner;
